<template>
  <div>
    <label class="font-lato mb-2 block text-lg text-ng800" :for="props.name">{{ props.label }}</label>
    <textarea
      class="peer block w-full rounded-sm border border-ng10 bg-transparent p-3 text-base leading-[1.2] text-ng800 transition duration-200 ease-out focus:border-[#8AA678] focus:outline-none focus:ring-1 focus:ring-[#8AA678]"
      :id="props.name"
      :name="props.name"
      required
      :rows="props.rows"
      v-model="value"
    ></textarea>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{
  name: string;
  rows: number;
  value: string;
  label: string;
}>();
const emit = defineEmits(["update:value"]);

const value = computed({
  get: () => {
    return props.value;
  },
  set: (value) => {
    emit("update:value", value);
  },
});
</script>
<style lang="scss" scoped></style>
